











































import Vue from "vue";
import Component from "vue-class-component";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import authFunctions from "@/plugins/firebase-functions/auth-functions";
import {firebaseAuth} from "@/plugins/firebase";
import {defaultPage} from "@/plugins/router";
import {Prop} from "vue-property-decorator";
import {RawLocation} from "vue-router";
import {safeRedirect} from "@/js/router-utils";
import {isHttpsError} from "@/common/js/firebase-utils";
import {authModule, store} from "@/store/store";

@Component({
    components: {
        ValidationProvider,
        ValidationObserver
    }
})
export default class LoginView extends Vue {

    @Prop({default: () => defaultPage, type: [String, Object]})
    readonly redirectTo!: RawLocation;

    username: string = "";
    password: string = "";

    loading: boolean = false;

    error = {
        message: "",
        show: false
    };

    beforeMount() {
        let redirected = false;
        const unsubscribe = store.watch(() => authModule.isLoggedIn, async (isLoggedIn) => {
            if (isLoggedIn) {
                unsubscribe();
                redirected = true;
                await safeRedirect(this.redirectTo);
            }
        }, {immediate: true});

        if (redirected) unsubscribe();
    }

    async submit() {
        this.loading = true;
        this.error.show = false;

        try {
            let token = await authFunctions.login(this.username, this.password);

            await firebaseAuth.signInWithCustomToken(token);
        } catch (error) {
            if (isHttpsError(error) && error.details === "invalid-credentials") {
                this.showError(this.$t("views.login.errors.invalid-credentials") as string);
            } else {
                this.showError(this.$t("views.login.errors.could-not-login") as string);
            }
        }

        this.loading = false;
    }

    showError(error: string) {
        this.error.message = error;
        this.error.show = true;
    }

}
